import { AddEditWarningLightComponent } from './add-edit-warning-light/add-edit-warning-light.component';
import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { UserRoleMenu } from '../../business-entities/user-role-menu.model';
import * as Enums from './../../../../../Autofacets-Core/src/app/utils/enums';
import { WarningLightService } from '../../business-services/warninglight.service';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { WarningLightListModel } from '../../business-entities/warning-light-view-model';
import { CookieService } from 'ngx-cookie-service';
import {
  NgbdSortableHeader,
  SortEvent,
} from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-warning-light',
  templateUrl: './warning-light.component.html',
})
export class WarningLightComponent implements OnInit {
  throttle = 100;
  scrollDistance = 1;
  popupCloseResult = false;

  userRoleRightsDetails: UserRoleMenu;
  warningLightList: WarningLightListModel[] = [];
  totalCount: number = 0;
  searchTerm: string;
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  constructor(
    private userService: UserDataService,
    private warningLightService: WarningLightService,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private cookieservice: CookieService,
    private translate: TranslateService,
    private toaster: ToastrService
  ) {}

  ngOnInit(): void {
    this.userRoleRightsDetails = (
      this.userService.currentUserValue.userRoleMenuDetails as any[]
    ).find((menu) => menu.moduleId === Enums.ModuleNames.WarningLights);
    this.warningLightList = [];
    this.getWarningLightList();
  }

  onScrollDown(_ev) {
    if (this.totalCount > this.warningLightList.length) {
      this.warningLightService.warningLightListRequest.startRecordNumber =
        this.warningLightList.length;
      this.getWarningLightList();
    }
  }

  onSort({ column, direction }: SortEvent) {
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.warningLightService.warningLightListRequest.sortColumn = column;
    this.warningLightService.warningLightListRequest.sortDirection = direction;
    this.warningLightService.warningLightListRequest.startRecordNumber = 0;
    this.warningLightList = [];
    this.getWarningLightList();
  }

  onSearchFilter() {
    this.warningLightService.warningLightListRequest.startRecordNumber = 0;
    this.warningLightService.warningLightListRequest.searchTerm = this.searchTerm;
    this.warningLightList = [];
    this.getWarningLightList();
  }



  async getWarningLightList() {
    this.spinner.show();
    this.warningLightService.warningLightListRequest.languageCode =
      this.cookieservice.get('userSelectedLanguage');
    await this.warningLightService
      .getWarningLightList(this.warningLightService.warningLightListRequest)
      .then(
        (response) => {
          this.spinner.hide();
          this.warningLightList.push(
            ...this.warningLightDataMapper(
              response.responseObject.warningLightList
            )
          );
          if (response.responseObject?.result?.errorCode == '5449') {
            this.totalCount = 0;
          } else {
            this.totalCount =
              this.warningLightList.length > 0
                ? this.warningLightList[0].totalCount
                : 0;
            this.spinner.hide();
          }
          this.spinner.hide();
        },
        (_error) => {
          this.spinner.hide();
        }
      );
  }

  onAddEdit(id: number) {
    this.warningLightService.Id = id;
    const modalref = this.modalService.open(AddEditWarningLightComponent, {
      size: 'lg',
      windowClass: 'EditPopup',
    });
    modalref.result.then((response) => {
      if (response.success) {
        this.ngOnInit();
      }
    });
  }

  deleteWarningLight(id: any) {
    let modelHeadermsg = this.translate.instant('lblDelete');
    let modelBodymsg = Utility.createMessage(
      this.translate.instant('lblSureToDelete'),
      this.translate.instant('lblWarningLight'),
      false
    );
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then(
      (_result) => {
        // This is intentional
      },
      (reason) => {
        this.popupCloseResult = this.getDismissReason(reason);
        if (this.popupCloseResult) {
          this.warningLightService.deleteWarningLight(id).then((response) => {
            if (response.responseCode == Constant.SuccessResponseCode && response.responseObject) {
              let successMsg = this.translate.instant('lblDeleteWarningLight');
              this.toaster.success(successMsg);
              this.warningLightService.warningLightListRequest.startRecordNumber = 0;
              this.warningLightList = [];
              this.getWarningLightList();
            }
            else
            {
              let errorMsg = this.translate.instant(
                'lblDeleteWarningLightErrorMsg'
              );
              this.toaster.error(errorMsg);
            }
            if (response.responseCode == Constant.ResponseCode) {
              let errorMsg = this.translate.instant(
                'lblDeleteWarningLightErrorMsg'
              );
              this.toaster.error(errorMsg);
            }
          });
        }
      }
    );
  }

  private warningLightDataMapper(warningLight: any) {
    let supperArray = [];
    if (warningLight && warningLight.length > 0) {
      for (let index = 0; index < warningLight.length; index++) {
        const element = warningLight[index];

        let single = Object();
        single.rowNumber =
          this.warningLightService.warningLightListRequest.startRecordNumber +
          1 +
          index;
        single.id = element.id;
        single.warningName = element.warningName;
        single.warningDescription = element.warningDescription;
        single.logo = element.logo;
        single.isActive=element.isActive;
        single.updatedDate = element.updatedDate
          ? new Date(element.updatedDate + 'Z')
          : null;
        single.createdDate = element.createdDate
          ? new Date(element.createdDate + 'Z')
          : null;
          single.totalCount=element.totalCount;
        supperArray.push(single);
      }
    }
    return supperArray;
  }
  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }
}
